import { insertChannelBurial } from "@/api/international.js";
import store from "@/store/index.js";
/**
 * 埋点事件
 * @param eventTypeCode 每个埋点事件类型固定值
 * @param extendField 每个埋点需要不同的参数，对象形式即可
 */
export function recordUserAction (
  eventTypeCode = "TODO",
  extendField = {}
) {
  let params = {
    // 当前网络标识 例如4G
    networkType: navigator.connection.effectiveType,
    // 当前电脑屏幕分辨率 不是浏览器分辨率
    screenResolution: screen.width + "x" + screen.height,
    userId: store.state.user.userId ? store.state.user.userId : '',
    eventTypeCode,
    extendField,
    // 当前时区
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  // 埋点接口 无需其他处理
  insertChannelBurial(params);
}



// WEBPACK FOOTER //
// ./src/utils/recordUserAction.js